import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { DeSoIdentityProvider } from "react-deso-protocol";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import "./themes.scss";
import { configure } from "deso-protocol";
import { ErrorProvider } from "./contexts/ErrorHandling.js";
import { AppLoader, LoadingScreen } from "./appLoader.js";
import { ExchangeRatesProvider } from "./contexts/ExchangeRatesContext.js";
import { UserPreferencesProvider } from "./contexts/UserPreferences.js";
import { AppDataProvider } from "./contexts/appData.js";
import { RedirectPage } from "./routes/tools/shareLink.jsx";
import W3lyComponent, { Create, AnalyseLink, EditLink, GetStarted, HomePage, LinksPage, Preferences } from "./w3ly.js";
import { Storage } from "./components/ImageTest.js";
import { AccessGroupsProvider } from "./contexts/AccessGroups.js";

//import App from './components/app.jsx'; // Import App directly
export const systemKey = process.env.REACT_APP_SYSTEM_KEY;
export const appName = process.env.REACT_APP_APPNAME;

const localPreferences = localStorage.getItem('preferences');
const desoActivePublicKey = localStorage.getItem('desoActivePublicKey');
let nodeURI = 'https://node.deso.org';
if (localPreferences) {
  const preferences = JSON.parse(localPreferences);
  if (desoActivePublicKey && preferences[desoActivePublicKey]) {
    nodeURI = preferences[desoActivePublicKey].nodeURI;
  } else {
    // Get the first available nodeURI from preferences
    const firstKey = Object.keys(preferences)[0];
    if (firstKey && preferences[firstKey].nodeURI) {
      nodeURI = preferences[firstKey].nodeURI;
    }
  }
}

configure({
  spendingLimitOptions: {
    "GlobalDESOLimit": 1000000000,
    "TransactionCountLimitMap": {
      "UPDATE_PROFILE": 1000000000,
      "CREATE_NFT": 1000000000,
      "UPDATE_NFT": 1000000000,
      "SUBMIT_POST": 1000000000,
      "NEW_MESSAGE": 1000000000,
      "BASIC_TRANSFER": 1000000000,
      "FOLLOW": 1000000000,
      "LIKE": 1000000000,
      "CREATOR_COIN": 1000000000,
      "CREATOR_COIN_TRANSFER": 1000000000,
      "ACCEPT_NFT_BID": 1000000000,
      "BURN_NFT": 1000000000,
      "CREATE_USER_ASSOCIATION": 1000000000,
      "CREATE_POST_ASSOCIATION": 1000000000,
      "ACCESS_GROUP": 1000000000,
      "ACCESS_GROUP_MEMBERS": 1000000000,
      "AUTHORIZE_DERIVED_KEY": 1
    },
    "CreatorCoinOperationLimitMap": {
      "": {
        "any": 1000000000
      }
    },
    "AssociationLimitMap": [
      {
        "AssociationClass": "Post",
        "AssociationType": "",
        "AppScopeType": "Any",
        "AppPublicKeyBase58Check": "",
        "AssociationOperation": "Any",
        "OpCount": 1000000000
      },
      {
        "AssociationClass": "User",
        "AssociationType": "",
        "AppPublicKeyBase58Check": "",
        "AppScopeType": "Any",
        "AssociationOperation": "Any",
        "OpCount": 1000000000
      }
    ],
    "AccessGroupLimitMap": [
      {
        "AccessGroupOwnerPublicKeyBase58Check": "",
        "ScopeType": "Any",
        "AccessGroupKeyName": "",
        "OperationType": "Any",
        "OpCount": 1000000000
      }
    ],
    "AccessGroupMemberLimitMap": [
      {
        "AccessGroupOwnerPublicKeyBase58Check": "",
        "ScopeType": "Any",
        "AccessGroupKeyName": "",
        "OperationType": "Any",
        "OpCount": 1000000000
      }
    ],
    "NFTOperationLimitMap": {
      "": {
        "0": {
          "any": 1000000000
        }
      }
    }
  },
  appName: appName,
  nodeURI: nodeURI,
  showSkip: true,
});

const ErrorBoundary = ({ children }) => {
  return (
    <React.Suspense fallback={<LoadingScreen />}>
      {children}
    </React.Suspense>
  );
};

const Root = () => (
  <DeSoIdentityProvider>
    <ErrorProvider>
      <UserPreferencesProvider>
        <AppDataProvider>
          <AccessGroupsProvider>
            <ExchangeRatesProvider>
              <Router>
                <Routes>
                  <Route path="/" element={<W3lyComponent />}>
                    <Route index element={<HomePage />} />
                    <Route path="get-started" element={<GetStarted />} />
                    <Route path="create" element={<Create />} />
                    <Route path="myshares" element={<LinksPage mode="myshares" />} />
                    <Route path="myqrcodes" element={<LinksPage mode="myqrcodes" />} />
                    <Route path="mylandingpages" element={<LinksPage mode="mylandingpages" />} />
                    <Route path="latest" element={<LinksPage mode="latest" />} />
                    <Route path="popular" element={<LinksPage mode="popular" />} />
                    <Route path="preferences" element={<Preferences />} />
                    <Route path="edit/:id" element={<EditLink />} />
                    <Route path="analyse/:id" element={<AnalyseLink />} />
                    <Route path="storageadmin" element={<Storage />} />
                  </Route>
                  <Route path="*" element={<RedirectPage />} />
                </Routes>
              </Router>
            </ExchangeRatesProvider>
          </AccessGroupsProvider>
        </AppDataProvider>
      </UserPreferencesProvider>
    </ErrorProvider>
  </DeSoIdentityProvider>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);


export const localFees = (TxnValue, fixedFee) => {
    let amountNanos;

    if(fixedFee) {
        amountNanos = fixedFee;
    } else if (!TxnValue || TxnValue === 0) {
        amountNanos = 1500;
    } else {
        const calculatedAmount = Math.floor(TxnValue * 0.1);
        amountNanos = calculatedAmount < 1500 ? 1500 : calculatedAmount; 
    }
    const payload = {
        PublicKeyBase58Check: systemKey,
        AmountNanos: amountNanos,
    };
    return payload;
}